import { render, staticRenderFns } from "./AdditionalVisitorSafeguardingHistory.vue?vue&type=template&id=7698423c&"
import script from "./AdditionalVisitorSafeguardingHistory.vue?vue&type=script&lang=js&"
export * from "./AdditionalVisitorSafeguardingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports